import { render, staticRenderFns } from "./excellent_student.vue?vue&type=template&id=9f29883a&scoped=true"
import script from "./excellent_student.vue?vue&type=script&lang=js"
export * from "./excellent_student.vue?vue&type=script&lang=js"
import style0 from "./excellent_student.vue?vue&type=style&index=0&id=9f29883a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f29883a",
  null
  
)

export default component.exports